import { Button, ButtonGroup } from '@revelio/ui';

import styles from './segmented-toggle.module.css';

type SegmentedToggleProps<T extends string> = {
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
  isDisabled?: boolean;
};

export const SegmentedToggle = <T extends string>({
  options,
  value,
  onChange,
  isDisabled = false,
}: SegmentedToggleProps<T>) => (
  <div className={styles.root}>
    <ButtonGroup size="sm" isAttached variant="outlined" disabled={isDisabled}>
      {options.map((option) => (
        <Button
          key={option.value}
          className={styles.button}
          aria-pressed={value === option.value}
          color={value === option.value ? 'primary' : 'default'}
          variant={value === option.value ? 'default' : 'outlined'}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </ButtonGroup>
  </div>
);
